<template>
    <div v-if="!watchStarted || isLoading" class="import-request-loading">
        <div class="text-center">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
            <div class="loading-text">
                {{$t('instance.data_model.check_data_model_status.checking')}}
            </div>
        </div>
    </div>

    <datamodel-checking-error
        v-else-if="hasError"
        :errors="result.errors">
    </datamodel-checking-error>
    <div v-else>
        <v-alert
            color="success"
            icon="check_circle"
            outlined
        >
            {{$t('instance.data_model.check_data_model_status.data_model_imported')}}
        </v-alert>
    </div>
</template>

<script>
import DatamodelCheckingError from '../datamodel-checking-error.vue';
import WaitingMixin from 'fundation-app-vuejs/src/components/partials/waitingMixin';
export default {
    mixins: [WaitingMixin],
    components: {
        DatamodelCheckingError
    },

    props: {
    },

    data (){
        return {
            watchStarted: false,
        };
    },
    computed: {

    },
    mounted (){

    },

    methods: {
        startWatch (url){
            this.watchRequestStatus(url);
            this.watchStarted = true;
        },
    },
};
</script>

<style lang="scss">
    .import-request-loading{
        display: flex;
        justify-content: center;
        align-items: center;

        .loading-text{
            margin-top: 15px;
            font-size: large;
            font-family: sans-serif;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/check-datamodel-status.vue